import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import ZoomConnection from './pages/ZoomConnection';
import Categorization from './pages/Categorization';
import Grading from './pages/Grading';
import Jobs from './pages/Jobs';
import Results from './pages/Results';
import AdminNavigator from './components/AdminNavigator';

const Health = () => {
  React.useEffect(() => {
    document.title = "ZoomFabric Health Check";
  }, []);

  return (
    <div style={{
      fontFamily: 'monospace',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '4px'
    }}>
      <pre>{JSON.stringify({
        status: "healthy",
        service: "zoomfabric",
        timestamp: new Date().toISOString(),
        version: "1.0.0"
      }, null, 2)}</pre>
    </div>
  );
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Navbar />
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/connection" element={<ZoomConnection />} />
              <Route path="/categorization" element={<Categorization />} />
              <Route path="/grading" element={<Grading />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/results" element={<Results />} />
              <Route path="/health" element={<Health />} />
            </Routes>
          </main>
          <AdminNavigator />
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;